<template>
  <table class="table mb-0" style=" text-align: left">
    <thead>
        <tr>
            <th style="width: 200px"></th>
            <th style="width: 200px">{{ t.navigation.total_amount_of_wager }}</th>
            <th style="width: 300px">{{ t.navigation.amount_of_prizes_paid}}</th>
            <th style="width: 300px">{{ t.navigation.total_profit}}</th>
        </tr>
    </thead>
    <tbody>
        <tr v-for="r in report">
            <td><strong>{{ r._name }}</strong></td>
            <td>{{ r.wager | toMoney(session.currency) }}</td>
            <td>{{ r.won | toMoney(session.currency) }}</td>
            <td :style="(r.casino_profit > 0) ? 'color: green' : 'color: red'">{{ r.casino_profit | toMoney(session.currency) }}</td>
        </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "ProviderCasino",
  props: ['id', 'start', 'end'],
  data() {
    return {
        t: this.$root.t,
      session: window.session,
      balance: {},
      report: []
    }
  },
  watch: {
    'id' () {
        this.fetchBalance();
    },
    'start' () {
      this.fetchBalance();
    },
    'end' () {
      this.fetchBalance();
    },
  },
  mounted () {
    this.fetchBalance();
  },
  methods: {
    fetchBalance(){
          this.$http.get(api + 'api/v1/reseller_casino_giro/'+this.id, {
            params: {
              start: this.start,
              end: this.end
            }
          })
          .then(response => {
            this.report = response.body.result;

            //this.totalBetProfit += this.balance.bet_profit;
            //this.totalCasinoProfit += this.balance.casino_profit;
            //this.total += parseFloat(this.balance.bet_profit);
            //this.total += parseFloat(this.balance.casino_profit);


          }, response => {

          })
    },
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/ProviderCasino.vue